// Facebook Meta Pixel utility — manual injection, no npm package needed

declare global {
  interface Window {
    fbq: ((...args: unknown[]) => void) & {
      callMethod?: (...args: unknown[]) => void
      queue: unknown[][]
      loaded: boolean
      version: string
      push: (...args: unknown[]) => void
    }
    _fbq: typeof window.fbq
  }
}

let initialized = false

export function initPixel(pixelId: string): void {
  if (initialized) return
  initialized = true

  const f = window
  const b = document

  if (f.fbq) return

  const n: Window['fbq'] = function (...args: unknown[]) {
    if (n.callMethod) {
      n.callMethod(...args)
    } else {
      n.queue.push(args)
    }
  } as Window['fbq']

  n.queue = []
  n.loaded = true
  n.version = '2.0'
  n.push = n

  if (!f._fbq) f._fbq = n
  f.fbq = n

  const t = b.createElement('script')
  t.async = true
  t.src = 'https://connect.facebook.net/en_US/fbevents.js'
  const s = b.getElementsByTagName('script')[0]
  s?.parentNode?.insertBefore(t, s)

  // Also add noscript fallback
  const ns = b.createElement('noscript')
  const img = b.createElement('img')
  img.height = 1
  img.width = 1
  img.style.display = 'none'
  img.src = `https://www.facebook.com/tr?id=${pixelId}&ev=PageView&noscript=1`
  ns.appendChild(img)
  b.body?.appendChild(ns)

  window.fbq('init', pixelId)
}

export function trackPageView(): void {
  if (window.fbq) {
    window.fbq('track', 'PageView')
  }
}

export function trackEvent(
  eventName: string,
  data?: Record<string, unknown>,
): void {
  if (window.fbq) {
    if (data) {
      window.fbq('track', eventName, data)
    } else {
      window.fbq('track', eventName)
    }
  }
}
